export default {"src":"/_next/static/media/right.954c4b21.svg","height":193,"width":161,"blurWidth":0,"blurHeight":0};